<template>
  <div class="toast" :class="`toast--${toast.type}`">
    <span>{{ toast.message }}</span>
    <button type="button" @click="close" :aria-label="translations['bookings.common.close']"><span class="icon icon--cross toast__close"></span></button>
  </div>
</template>

<script setup lang="ts">
import type { Toast } from '@components/Toast/Toast';
import { getTranslations } from '@services/translations';

const translations = getTranslations();

defineProps<{
  toast: Toast;
}>();
const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};

</script>
